module.exports = __webpack_public_path__ + "static/img/img_description_of_soldoc1.9fa3787.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_mobile/img_description_of_soldoc1.png
// module id = NwZD
// module chunks = 0